export default "__VITE_ASSET__Yazpm7WX__"